// Average advance of a --fs-sm character, to cut labels before they spill.
export const CHAR = 6.4;

/** ``label`` cut with an ellipsis to fit ``px``. */
export function fitLabel(label: string, px: number): string {
  const max = Math.max(4, Math.floor(px / CHAR));
  return label.length <= max ? label : `${label.slice(0, max - 1)}…`;
}

/** The largest pixels-per-unit that fits ``values`` into ``room``, when no
 * node may be shorter than ``min``. */
export function scaleFor(values: number[], min: number, room: number): number {
  let fixed = new Set<number>();
  let k = Infinity;
  for (let pass = 0; pass <= values.length; pass++) {
    const free = values.reduce((s, v, i) => (fixed.has(i) ? s : s + v), 0);
    k = free > 0 ? (room - min * fixed.size) / free : Infinity;
    const next = new Set(values.flatMap((v, i) => (v * k < min ? [i] : [])));
    if (next.size === fixed.size) break;
    fixed = next;
  }
  return k;
}
